<template>
  <v-footer
    color="#1D2939"
    :absolute="absolute"
    style="margin-top: auto"
    class="white--text text-caption hidden-md-and-down footer-center"
  >
    <v-row no-gutters align="center" justify="center">
      <v-img src="@/assets/logofs.svg" width="80" class="footer-logo"></v-img>
      <span class="footer-text">
        Copyright © Forward System Limited. All rights reserved.
      </span>
    </v-row>
  </v-footer>
</template>
<script>
export default {
  props: {
    absolute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.footer-center {
  display: flex;
  justify-content: center;
}

.footer-logo {
  flex: 0 0 auto;
  margin-top: 4px;
  margin-right: 12px;
  max-width: 80px;
}

.footer-text {
  color: white;
  font-size: small;
  margin-bottom: 5px;
}
</style>
